/** Page fiche client : on y entre depuis la liste. */
import { Button } from "../../components/Button";
import { ClientPieceTabs } from "./ClientPieceTabs";
import { ClientProfile } from "./ClientProfile";
import "./clientShow.css";
import type { Client, ClientListItem } from "./types";

type ClientShowProps = {
  client: Client;
  stats?: Pick<ClientListItem, "balance_cents" | "paid_to_date_cents"> | null;
  busy: boolean;
  onBack: () => void;
  onEdit: () => void;
  onStatement: () => void;
  onArchive: () => void;
  onDelete: () => void;
  onCheckSirene: () => void;
  onNewQuote?: () => void;
  onOpenQuote?: (id: number) => void;
  onNewInvoice?: () => void;
  onOpenInvoice?: (id: number) => void;
  onNewRecurring?: () => void;
  onOpenRecurring?: (id: number) => void;
  onLedgerChange?: () => void;
};

export function ClientShow({
  client,
  stats,
  busy,
  onBack,
  onEdit,
  onStatement,
  onArchive,
  onDelete,
  onCheckSirene,
  onNewQuote,
  onOpenQuote,
  onNewInvoice,
  onOpenInvoice,
  onNewRecurring,
  onOpenRecurring,
  onLedgerChange,
}: ClientShowProps) {
  return (
    <div className="fx-fiche">
      <header className="fx-fiche-head">
        <div className="fx-fiche-head__id">
          <button type="button" className="fx-fiche-back" onClick={onBack}>
            ← Clients
          </button>
          <h1>
            {client.name}
            {client.archived ? <span className="fx-fiche-head__badge">Archivé</span> : null}
          </h1>
          {client.display_name?.trim() ? <p className="m-0 text-sm" style={{ color: "var(--fx-muted)" }}>{client.display_name.trim()}</p> : null}
        </div>
        <div className="fx-fiche-head__acts">
          <Button onClick={onEdit} disabled={busy}>
            Éditer
          </Button>
          <Button variant="ghost" onClick={onStatement} disabled={busy}>
            Relevé
          </Button>
          <Button variant="ghost" onClick={onArchive} disabled={busy}>
            {client.archived ? "Désarchiver" : "Archiver"}
          </Button>
          <Button variant="danger" onClick={onDelete} disabled={busy}>
            Supprimer
          </Button>
        </div>
      </header>
      <ClientProfile client={client} stats={stats} busy={busy} onCheckSirene={onCheckSirene} onOpenQuote={onOpenQuote} onOpenInvoice={onOpenInvoice} />
      <ClientPieceTabs
        client={client}
        onNewQuote={onNewQuote}
        onOpenQuote={onOpenQuote}
        onNewInvoice={onNewInvoice}
        onOpenInvoice={onOpenInvoice}
        onNewRecurring={onNewRecurring}
        onOpenRecurring={onOpenRecurring}
        onLedgerChange={onLedgerChange}
      />
    </div>
  );
}
